import React from 'react';
import cx from 'classnames';
import {createDesignSystemComponent, Color, TypeScale} from '../designSystem/designSystem';
import {Filter} from '../utils/typeUtils';

export const Paragraph = createDesignSystemComponent<
  Filter<Color, 'grey-90' | 'grey-60'> | Filter<TypeScale, 'f4' | 'f5'>,
  React.HTMLAttributes<HTMLParagraphElement>
>(({className, ...props}) => <p {...props} className={cx('lh-copy f4 mv3', className)} />);
